import { render, staticRenderFns } from "./ShieldFail.vue?vue&type=template&id=18a18b60&"
import script from "./ShieldFail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShieldFail.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports